






















































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Header from '@/components/common/Header.vue';
import Menu from '@/components/common/Menu.vue';
import RemoveWorkspaceDialog from '@/components/settings/RemoveWorkspaceDialog.vue';
import { workspaceService } from '@/services/WorkspaceService';
import EventBus from '@/EventBus';
import { mapState } from 'vuex';
import { storeService } from '@/services/StoreService';

@Component({
  components: {
    Header,
    Menu,
    RemoveWorkspaceDialog,
  },
  computed: {
    ...mapState({
      userRole: (state: any) => state.currentWorkspace.role,
      workspaceData: (state: any) =>
        state.workspaces.workspaces.find(
          (item: any) => parseInt(item.id, 10) === parseInt(state.currentWorkspace.id, 10)
        ) || {},
    }),
  },
})
export default class Settings extends Vue {
  isEditingWorkspaceNameHidden = true;
  workspaceSettings: any = {};
  isWorkspaceNameEmpty = false;
  workspaceId = 0;
  workspaceName = '';
  isUnsubscribeModalShown = false;
  is2FAModalShown = false;
  isLoading = false;

  @Watch('$store.state.currentWorkspace.workspaceName', { immediate: true, deep: true })
  onWorkspaceNameChange(data: any) {
    this.workspaceName = data;
    this.workspaceSettings.workspace_name = data;
    this.workspaceSettings = { ...this.workspaceSettings };
  }

  mounted() {
    this.workspaceId = parseInt(this.$route.params.workspaceId, 10);
    this.getSettings();
  }

  onUnsubscribeModalClose() {
    this.isUnsubscribeModalShown = false;
  }
  on2FAModalClose() {
    this.is2FAModalShown = false;
  }

  getSettings() {
    workspaceService.getSettings(this.workspaceId).then((data: any) => {
      this.workspaceSettings = data;
    });
    storeService.getWorkspaceName();
  }

  updateWorkspaceName() {
    if (this.workspaceSettings.workspace_name === '') {
      this.isWorkspaceNameEmpty = true;
    } else {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      workspaceService
        .updateWorkspaceName(this.workspaceId, {
          name: this.workspaceSettings.workspace_name,
        })
        .then(() => {
          this.isLoading = false;
          this.isEditingWorkspaceNameHidden = true;
          this.workspaceName = this.workspaceSettings.workspace_name;
          EventBus.$emit('workspace-name-change', this.workspaceSettings.workspace_name);
        })
        .catch(() => {
          this.isLoading = false;
        });
    }
  }

  cancelName() {
    this.isEditingWorkspaceNameHidden = !this.isEditingWorkspaceNameHidden;
    this.workspaceSettings.workspace_name = this.workspaceName;
    this.isWorkspaceNameEmpty = false;
  }

  unsubscribeFromWorkspace() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    workspaceService
      .unsubscribeFromWorkspace(this.workspaceId)
      .then(() => {
        this.isLoading = false;
        this.onUnsubscribeModalClose();
        this.$router.push('/workspace-switch').catch(() => {});
      })
      .catch(() => {
        this.isLoading = false;
      });
  }
}
